import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';
import { Error } from 'app/core/error-handler/models';

import { LoginUuidModel } from 'app/core/authentication/models';

export class LoginUuid implements Action {
  public readonly type: AuthActionType = AuthActionType.LoginUuid;
  public readonly payload: LoginUuidModel;

  constructor(uuid: string, isFirstLoad: boolean) {
    this.payload = {uuid, isFirstLoad}
    ;
  }
}

export class CheckLoginUuid implements Action {
  public readonly type: AuthActionType = AuthActionType.CheckLoginUuid;
  public readonly payload: LoginUuidModel;

  constructor(uuid: string, isFirstLoad: boolean) {
    this.payload = {uuid, isFirstLoad}
    ;
  }
}

export class LoginUuidCompleted implements Action {
  public readonly type: AuthActionType = AuthActionType.LoginUuidCompleted;

  constructor(public readonly payload: string) { }
}

export class LoginUuidFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.LoginUuidFailed;

  constructor(public readonly payload: Error) { }
}
